/**
 * Sync GFE seller/marketplace labels into shell context bar + prefs.
 * One way: Global Filter is source of truth for business dimensions.
 */
import { useEffect } from 'react';
import { useShell } from '../shell/ShellProvider';
import { useGlobalFilter } from './GlobalFilterProvider';

export function GlobalFilterShellBridge() {
  const { context } = useGlobalFilter();
  const { setContextLabels } = useShell();

  useEffect(() => {
    setContextLabels({
      sellerLabel: context.sellerLabel,
      marketplace: context.marketplace,
    });
  }, [context.sellerLabel, context.marketplace, setContextLabels]);

  return null;
}
